import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.seal.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import { COMPANY_ACTIVITY_TYPES } from '~/const/user/index';
import { getAccountCreationDateFromToken } from '~/helpers/token-audience-helpers';
export default {
  name: 'CustomizableHomePageTcVars',
  props: {
    vars: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var _ref;
    return {
      tcVars: Object.seal({
        env_country: '',
        env_language: '',
        env_template: ((_ref = this.vars) != null ? _ref.env_template : _ref) || '',
        // TODO check
        page_url: this.$route.path,
        user_category: '',
        user_activite_pro: '',
        user_email: '',
        user_email_256: '',
        user_firstorder_date: '',
        user_firstvisit_date: '',
        user_frequency: '',
        user_id: '',
        user_lastorder_date: '',
        user_logged: false,
        user_postalcode: '',
        user_recency: '',
        user_authentification: null,
        user_subscription_date: '',
        earlybirds_widgets: null,
        is_store: '',
        rcu_id: '',
        store_id: '',
        store_vendor_id: '',
        store_name: ''
      })
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    user: 'user/me',
    seller: 'seller/me'
  })),
  created: function created() {
    var _this = this;
    if (this.isCorrectLayout()) {
      this.setTcVars('init editorial');
      this.$root.$on('reset-tcvars', function () {
        // eslint-disable-next-line nuxt/no-globals-in-created
        if (window && !window.isTcContainerLoadedBefore) {
          _this.setTcVars('editorial reset tcVars');
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('reset-tcvars');
  },
  methods: {
    isCorrectLayout: function isCorrectLayout() {
      // Issue : https://github.com/nuxt/nuxt.js/issues/3877
      return this.$nuxt.$data.layoutName === 'default';
    },
    setTcVars: function setTcVars(message) {
      this.tcVars.env_country = this.locale.market;
      this.tcVars.env_language = this.locale.language;
      this.tcVars.user_logged = Boolean(this.user);
      if (this.user && process.client) {
        var _this$user$company;
        var _ref2 = JSON.parse(window.localStorage.getItem('MDM_MAILS')) || {},
          typeA = _ref2.type_A,
          typeB = _ref2.type_B;
        this.tcVars.user_email = typeA || '';
        this.tcVars.user_email_256 = typeB;
        this.tcVars.user_authentification = window.localStorage.getItem('MDM_USER_AUTHENTIFICATION') || '';
        this.tcVars.rcu_id = this.user.rcuId;
        this.tcVars.user_id = this.user.id;
        this.tcVars.user_category = this.$cookies.get('MDM[statut]') || '';
        this.tcVars.user_activite_pro = COMPANY_ACTIVITY_TYPES[(_this$user$company = this.user.company) === null || _this$user$company === void 0 ? void 0 : _this$user$company.activity] || '';
        this.tcVars.user_firstvisit_date = this.$cookies.get('MDM[date_first_visit]');
        this.tcVars.user_subscription_date = getAccountCreationDateFromToken() || '20200101';
      }
      if (this.seller) {
        this.tcVars.is_store = !!this.seller;
        this.tcVars.store_id = this.seller.shopId;
        this.tcVars.store_vendor_id = this.seller.uid;
        this.tcVars.store_name = this.seller.username;
      }
      if (process.client) {
        this.tcVars.earlybirds_widgets = JSON.parse(localStorage.getItem('EARLYBIRDS_WIDGETS'));
      }
      if (process.client && this.$cookies.get('debugmdm')) {
        console.log(message, _objectSpread({}, this.tcVars));
      }
      this.$root.$emit('updated-tcvars', this.tcVars);
    }
  },
  render: function render(h) {
    return h(null);
  }
};